import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ClientDataStoreService } from '../services/client-data-store.service';
import { catchError, filter, map, Observable, of } from 'rxjs';

@Injectable()
export class ClientTermsResolver {

  constructor(private router: Router, private clientStore: ClientDataStoreService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.clientStore.terms$.pipe(
      filter(result => !!result),
      map(result => result),
      catchError(error => {
        console.log(`Whoops, we're unable to resolve client terms. Might want to look into that! Here's the error message: ${error}`);
        
        return of(null);
      }));
  }
}